import {
  Card,
  CardBody,
  CardHeader,
  Flex,
  HStack,
  StackDivider,
  Stat,
  StatLabel,
  StatNumber,
  StyleProps,
  VStack,
} from "@chakra-ui/react";
import { useFeeChargeEventStatsChartRetrieveSuspense } from "gen/endpoints/fees/fees";
import { useTranslation } from "react-i18next";
import { MaybernChartWrapper } from "shared/components/chart/MaybernChartWrapper";
import {
  chartStatFormatters,
  moneyLabelFormatter,
} from "shared/components/chart/utils";
import colors from "theme/colors";

export const FundFamilySummaryChartFees: React.FC<
  StyleProps & {
    fundFamilyId: string;
  }
> = ({ fundFamilyId, ...props }) => {
  const { t } = useTranslation(["fundFamily"]);

  const { data: chartData } =
    useFeeChargeEventStatsChartRetrieveSuspense(fundFamilyId);
  return (
    <Card variant="chart" {...props}>
      <CardHeader>{t("fundFamily:summary.charts.fees.title")}</CardHeader>
      <CardBody>
        <VStack divider={<StackDivider height={2} />}>
          <Flex justifyContent="center" width="100%" height="330px">
            <MaybernChartWrapper
              {...chartData}
              palette={{
                fills: [
                  colors.cyan[700],
                  colors.cyan[500],
                  colors.gray[150],
                  colors.gray[200],
                ],
              }}
              legendPosition="bottom"
              padding={{
                top: 4,
                right: 16,
                bottom: 0,
                left: 16,
              }}
              seriesConfig={{
                stacked: true,
                cornerRadius: 8,
              }}
              yAxis={{
                labelFormatter: moneyLabelFormatter,
              }}
              xAxis={{
                label: t("fundFamily:summary.charts.fees.xAxisLabel"),
              }}
            />
          </Flex>
          <HStack
            width="30%"
            mt="16px"
            mb="16px"
            justifyContent="center"
            alignItems="center"
            spacing={30}
          >
            {chartData.stats?.map((item) => (
              <VStack key={item.label}>
                {item.stat?.value && (
                  <Stat size="sm">
                    <StatNumber>
                      {chartStatFormatters[item.stat.type](item.stat as never)}
                    </StatNumber>
                  </Stat>
                )}
                <Stat size="xs">
                  <StatLabel>{item.label}</StatLabel>
                </Stat>
              </VStack>
            ))}
          </HStack>
        </VStack>
      </CardBody>
    </Card>
  );
};
